// ============================================================
// Globo Asiatico — Access Rights
// Range: 8101–8699
// ============================================================

export const GLOBO_ACCESS_RIGHTS = {

  //#region PATIENTS
  GLOBO_PATIENTS:                                               8101,
  GLOBO_PATIENTS_PRESCRIPTIONS:                                 8102,
  GLOBO_PATIENTS_ORDERS:                                        8103,
  GLOBO_PATIENTS_FILES:                                         8104,
  GLOBO_PATIENTS_LOGS:                                          8105,
  //#endregion

  //#region STATIC DATA
  GLOBO_STATICDATA_DIAGNOSIS:                                   8501,
  GLOBO_STATICDATA_DOCTORS:                                     8502,
  GLOBO_STATICDATA_DROPOUTREASONS:                              8503,
  GLOBO_STATICDATA_HOSPITALS:                                   8504,
  GLOBO_STATICDATA_PAPSCHEMES:                                  8505,
  GLOBO_STATICDATA_PATIENTSEGMENTS:                             8506,
  GLOBO_STATICDATA_PRINCIPALS:                                  8507,
  GLOBO_STATICDATA_PRODUCTS:                                    8508,
  GLOBO_STATICDATA_PROGRAMS:                                    8509,
  GLOBO_STATICDATA_PURCHASINGACCOUNTS:                          8510,
  GLOBO_STATICDATA_SPECIALIZATIONS:                             8511,
  GLOBO_STATICDATA_THERAPEUTICAREAS:                            8512,
  GLOBO_STATICDATA_TREATMENTSTATUSES:                           8513,
  GLOBO_STATICDATA_UOMS:                                        8514,
  //#endregion

  //#region TRANSACTIONS — ADVERSE EVENTS
  GLOBO_TRANSACTIONS_ADVERSEEVENTS:                             8601,
  //#endregion

  //#region TRANSACTIONS — DOCTOR ENROLLMENTS
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_VIEWER:                  8602,
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_REQUESTOR:               8603,
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_APPROVER:                8604,
  //#endregion

  //#region TRANSACTIONS — LOA REQUESTS
  GLOBO_TRANSACTIONS_LOAREQUESTS_VIEWER:                        8605,
  GLOBO_TRANSACTIONS_LOAREQUESTS_REQUESTOR:                     8606,
  GLOBO_TRANSACTIONS_LOAREQUESTS_APPROVER:                      8607,
  //#endregion

  //#region TRANSACTIONS — ORDER REQUESTS
  GLOBO_TRANSACTIONS_ORDERREQUESTS_VIEWER:                      8608,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_REQUESTOR:                   8609,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_APPROVER:                    8610,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_SET_RECEIVED:                8611,
  //#endregion

  //#region TRANSACTIONS — PATIENT ENROLLMENTS
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_VIEWER:                 8612,
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_REQUESTOR:              8613,
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_APPROVER:               8614,
  //#endregion

  //#region TRANSACTIONS — PRESCRIPTION REQUESTS
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_VIEWER:               8615,
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_REQUESTOR:            8616,
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_APPROVER:             8617,
  //#endregion

};